var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.625 12.0005C23.625 5.57861 18.4219 0.375488 12 0.375488C5.57812 0.375488 0.375 5.57861 0.375 12.0005C0.375 17.8027 4.62609 22.6121 10.1836 23.4849V15.361H7.23047V12.0005H10.1836V9.43924C10.1836 6.52596 11.918 4.91674 14.5744 4.91674C15.8466 4.91674 17.1769 5.14361 17.1769 5.14361V8.00299H15.7106C14.2669 8.00299 13.8164 8.89924 13.8164 9.81846V12.0005H17.0405L16.5248 15.361H13.8164V23.4849C19.3739 22.6121 23.625 17.8027 23.625 12.0005Z","fill":"#E6EAF4"}));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
